
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zbvjxryqzrygkixfuidj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inpidmp4cnlxenJ5Z2tpeGZ1aWRqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDEwMTIwMDUsImV4cCI6MjA1NjU4ODAwNX0.5YMdkhnZhxNsDNPcltXxQShVT4rArP9gp65LeMky4gQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0',
    },
  },
});

// Add some debug logging to help troubleshoot column name issues
console.log("Supabase client initialized");

// Function to help debug column issues
export const debugSupabaseQuery = async (tableName: string) => {
  try {
    const { data, error } = await (supabase as any)
      .from(tableName)
      .select('*')
      .limit(1);
    
    if (error) {
      console.error(`Error querying ${tableName}:`, error);
    } else if (data && data.length > 0) {
      console.log(`${tableName} sample data:`, data[0]);
      console.log(`${tableName} columns:`, Object.keys(data[0]));
    }
  } catch (e) {
    console.error(`Exception querying ${tableName}:`, e);
  }
};

// Special debug function for the stories table to check if 'published' column exists
export const debugStoriesTable = async () => {
  try {
    const { data, error } = await supabase
      .from('stories')
      .select('*')
      .limit(1);
    
    if (error) {
      console.error('Error querying stories:', error);
    } else if (data && data.length > 0) {
      console.log('Stories sample data:', data[0]);
      console.log('Stories columns:', Object.keys(data[0]));
      
      // Check if 'published' column exists (case-sensitive check)
      if ('published' in data[0]) {
        console.log("✅ 'published' column exists (lowercase)");
      } else if ('Published' in data[0]) {
        console.log("⚠️ 'Published' column exists (uppercase first letter)");
        console.warn("Column case mismatch detected. Database has 'Published' but code expects 'published'");
      } else {
        console.log("❌ No 'published' column found in any case");
      }
    }
  } catch (e) {
    console.error('Exception querying stories:', e);
  }
};

// Add a function to create normalized story objects that work regardless of column casing
export const normalizeStory = (story: any) => {
  if (!story) return story;
  
  // Create a normalized copy with consistent lowercase keys
  const normalized = {...story};
  
  // Handle the published/Published column inconsistency
  if ('Published' in story && !('published' in story)) {
    normalized.published = story.Published;
  }
  
  return normalized;
};
